<template>
  <div class="dapp-pagination">
    <template v-for="(meta,i) in metas">
      <template v-if="meta[0] === 'prev'">
        <a @click="onClick(meta[1])" :key="i">&lt;</a>
      </template>

      <template v-else-if="meta[0] === 'next'">
        <a @click="onClick(meta[1])" :key="i">&gt;</a>
      </template>

      <template v-else-if="meta[0] === 'current'">
        <span class="current" :key="i">{{ meta[1] }}</span>
      </template>

      <template v-else-if="meta[0] === 'page'">
        <a @click="onClick(meta[1])" :key="i">{{ meta[1] }}</a>
      </template>

      <template v-else-if="meta[0] === 'more'">
        <span :key="i">...</span>
      </template>

    </template>
  </div>
</template>

<script>
  export default {
    name: 'DAppPagination',
    props: ['total', 'current', 'onClickHandler'],
    data () {
      return {
        metas: this.getMeta()
      }
    },
    watch: {
      total () {
        this.metas = this.getMeta()
      },
      current () {
        this.metas = this.getMeta()
      }
    },
    methods: {
      getMeta () {
        let meta = page_nav(this.current, this.total)
        console.log('get meta', this.current, this.total, meta)
        return meta
      },
      onClick (index) {
        this.onClickHandler && this.onClickHandler(index)
      }
    }
  }

  /**
   * 生成页码导航数据
   *
   * @param current 当前页面
   * @param total 总页数
   * @param offset 当前页面前后要显示的页数
   * @param endsOffset 两端要显示的页数
   * @return {*} [['prev', 1], ['current', 1], ['page', 2], ['page', 3], ['more', 0], ['page', 20], ['next', 2]]
   */
  export function page_nav (current, total, offset = 1, endsOffset = 0) {
    if (total < 1 || current < 1 || current > total || offset < 0) {
      return null
    }
    const arr = []

    if (current > 1) {
      arr.push(['prev', current - 1])
    }

    const current_start = Math.max(current - offset, 1)
    const current_end = Math.min(current + offset, total)

    const start_start = 1
    const start_end = start_start + endsOffset

    const end_start = total - endsOffset
    const end_end = total

    function add (i) {
      if (i !== current) {
        arr.push(['page', i])
      } else {
        arr.push(['current', i])
      }
    }

    for (let i = start_start; i <= Math.min(start_end, current_start - 1); ++i) {
      add(i)
    }

    if (current_start - start_end > 1) {
      arr.push(['more', 0])
    }

    for (let i = current_start; i <= current_end; ++i) {
      add(i)
    }

    if (end_start - current_end > 1) {
      arr.push(['more', 0])
    }

    for (let i = Math.max(current_end + 1, end_start); i <= end_end; ++i) {
      add(i)
    }

    if (current < total) {
      arr.push(['next', current + 1])
    }
    return arr
  }

</script>

<style lang="scss" scoped>
  @import "../utils";

  .dapp-pagination {
    display: inline-block;
    > * {
      @extend .box-shadow-light;
      background-color: white;
      border-radius: 100px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      min-width: 40px;
      padding: 0 10px;
      text-align: center;
      vertical-align: middle;
      margin-bottom: 10px;

      &.current {
        font-weight: bold;
      }

      &.disabled {
        pointer-events: none;
      }

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/widgets/DAppPagination.vue